/* eslint-disable @typescript-eslint/member-ordering */

import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { IconComponent } from '@libs/components/icons';
import { ConfigurableBundleFormStateModel, ConfigurableBundleFormStateSlotModel, ConfigurableBundleSlotType } from '@libs/shop/models';
import { ConfigurableBundleFormUiService } from '../configurable-bundle-form-ui.service';

@Component({
  selector: 'ui-configurable-bundle-form-slots-info',
  imports: [
    MatCard,
    IconComponent,
  ],
  templateUrl: './configurable-bundle-form-slots-info.component.html',
  styleUrl: './configurable-bundle-form-slots-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurableBundleFormSlotsInfoComponent {
  private readonly configurableBundleFormUiService: ConfigurableBundleFormUiService = inject(ConfigurableBundleFormUiService);
  public bundleState: InputSignal<ConfigurableBundleFormStateModel> = input.required();
  public slotStates: Signal<ConfigurableBundleFormStateSlotModel[]> = computed(() => this.bundleState().slotMap.values().toArray());

  public choiceSlot: Signal<ConfigurableBundleFormStateSlotModel | undefined> = computed(() => this.slotStates().find(x => x.slotType === 'choice'));
  public freeSlot: Signal<ConfigurableBundleFormStateSlotModel | undefined> = computed(() => this.slotStates().find(x => x.slotType === 'free'));

  public getSlotLabelBySlotType(slotType: ConfigurableBundleSlotType): string {
    return this.configurableBundleFormUiService.getSlotLabelBySlotType(slotType);
  }
}
